import { Grid } from "@material-ui/core";
import styles from "./Snackbar.module.scss";
import { ReactComponent as FailIcon } from "../../../images/icon-error-info.svg";

export const FinalisedFailMessage = (props: { onClose: any }) => {

    const handleClose = () => {
        props.onClose();
    };

    return (
        <Grid container className={styles.failBackground}>
            <Grid xs={1} container className={styles.statusIcon}>
                <FailIcon></FailIcon>
            </Grid>
            <Grid xs={10} container className={styles.content}>
                <div>
                    <label className={styles.errorText}> The medication order has not been sent to the pharmacy.</label> Please <a className={styles.supportLink} href="mailto: Residential.Helpdesk@health.telstra.com">contact support</a> for assistance.
                </div>
            </Grid>
            <Grid item container direction="column" xs={1}>
                <Grid item xs container className={styles.actionContent}>
                    <div>
                        <a onClick={handleClose} className={styles.link}> Dismiss </a>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
}